import 'alpinejs';
import Vue from 'vue';

Vue.config.devtools = false;
Vue.config.silent = true;

/**
 * Header Menu
 */
function headerTransitions () {
  let header = document.getElementById('header');

  if (header) {
    if (window.scrollY > 0) {
      header.classList.remove('bg-opacity-100');
      header.classList.add('bg-opacity-100');
    } else {
      header.classList.remove('bg-opacity-100');
      header.classList.add('bg-opacity-100');
    }
  }
}

headerTransitions();

document.addEventListener('scroll', () => {
  headerTransitions();
});
